module.exports = __webpack_public_path__ + "static/media/GTEestiDisplay-Regular.4c115056.woff";